<template>
    <div class="ref_box_container new_ref_type"  @click="goToNew">
        <div class="ref_box">
            <div class="ref_box_icon middle_opacity">

            <IconRef />

            </div>
            <div class="ref_box_name new_item">
                {{ $t('modules.refs.index.refsList.newRefLabel') }}
            </div>
            <div class="icon_plus">
                <i class="icon-plus"></i>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NewRefItem',
    data(){
        return {
        }
    },
    methods: {
        goToNew(){
            console.log('sdfojsdoif')
            this.$router.push('/refs/new')
        }
    }
}
</script>

<style lang="scss">
.new_ref_type{
    cursor: pointer;
}
.icon_plus{
    font-size: 4rem;
    color: $info;
}
.ref_box_name.new_item{
    color: $info;
    font-weight: 600;
}
.middle_opacity{
    opacity: .5;
}
</style>